<template>
  <transition>
    <slot v-if="open" v-bind="$attrs"> </slot>
  </transition>
</template>

<script lang="ts">
export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.v-enter-active {
  animation: fade-in 0.5s cubic-bezier(0.03, 0.75, 0, 1) forwards;
}

.v-leave-active {
  animation: fade-in 0.2s cubic-bezier(0.03, 0.75, 0, 1) reverse;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
